import { render, staticRenderFns } from "./ListDialog.vue?vue&type=template&id=2fb7895e&scoped=true"
import script from "./ListDialog.vue?vue&type=script&lang=js"
export * from "./ListDialog.vue?vue&type=script&lang=js"
import style0 from "./ListDialog.vue?vue&type=style&index=0&id=2fb7895e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb7895e",
  null
  
)

export default component.exports